import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { tmpFonts } from "../../api/tmpData/tmpFonts";

const FontFamilySelect = (props) => {
  const { availableFonts, ...otherProps } = props;

  // Filter fonts
  const filteredFonts =
    availableFonts && Array.isArray(availableFonts) && availableFonts.length > 0
      ? tmpFonts.filter((font) => availableFonts.includes(font.fntId))
      : tmpFonts;

  return (
    <TextField
      fullWidth
      select
      InputLabelProps={{ shrink: true }}
      label={props.label || "Font Family Select"}
      variant="outlined"
      {...otherProps}
    >
      {filteredFonts.map((el) => {
        return (
          <MenuItem key={el.fntId} value={el.withFallback}>
            {el.name}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default FontFamilySelect;
